<template>
	<modal
		:exibir="exibir"
		:titulo="tituloModal"
		@close="fecharModal"
		:custom-actions="false"
		:acao-cancelar="fecharModal"
		:acao-confirmar="salvarSelecao"
		:is-confirmar-visivel="true"
		nome-botao-confirmar="Salvar"
		:tamanho="modalOptions"
		:max-width="modalOptions.largura"
		classe-personalizada-body="mt-5"
	>
		<template #body>
			<v-row>
				<v-col cols="12">
					<v-form lazy-validation ref="form">
						<label-personalizado
							nome-campo="Órgão Gerenciador"
							:obrigatorio-por-padrao="true"
						></label-personalizado>
						<v-autocomplete
							:items="orgaos"
							v-model="orgaoSelecionado"
							item-value="idOrgao"
							:filter="orgaoFilter"
							:rules="orgaoRule"
							v-validate="{ required: true }"
							name="Processo"
							:search-input.sync="nomeOuSiglaOrgao"
							placeholder="Selecione órgão"
							class="pt-0"
							:debounce-search="250"
							return-object
							@update:search-input.capture="carregarOrgaos"
						>
							<template #item="{ item }">
								<div
									v-html="$options.filters.HighlightBuscaFilter(item.siglaDescricao, textoBuscaOrgao)"
								></div>
							</template>
							<template #selection="{ item }">
								<texto-tooltip :tamanho-maximo="35" :texto="item.siglaDescricao"></texto-tooltip>
							</template>
						</v-autocomplete>
					</v-form>
				</v-col>
			</v-row>
		</template>
	</modal>
</template>
<script>
import TextoTooltip from '@/views/components/TextoTooltip.vue'
import HighlightBuscaFilter from '@/views/filters/highlight-busca-filter'

export default {
	name: 'modal-selecionar-orgao-gerenciador',
	components: { TextoTooltip },
	filters: { HighlightBuscaFilter },
	props: {
		exibir: {
			type: Boolean,
		},
		tituloModal: {
			type: String,
			default: '',
		},
		orgaos: {
			type: Array,
			required: true,
		},
	},
	emits: ['fechar', 'orgao-selecionado', 'buscar-orgaos'],
	data() {
		return {
			orgaoSelecionado: null,
			nomeOuSiglaOrgao: null,
			modalOptions: {
				largura: '450',
			},
			textoBuscaOrgao: '',
			orgaoRule: [(v) => !!v || 'Selecione um órgão para continuar'],
		}
	},
	methods: {
		async carregarOrgaos() {
			this.$emit('buscar-orgaos', this.nomeOuSiglaOrgao)
		},
		async salvarSelecao() {
			if (this.$refs.form.validate()) {
				this.$emit('orgao-selecionado', this.orgaoSelecionado)
			}
		},
		fecharModal() {
			this.$emit('fechar')
			this.orgaoSelecionado = null
			this.textoBuscaOrgao = ''
		},
		orgaoFilter(item, queryText) {
			const textoSiglaDescricao = item.siglaDescricao.toLowerCase()
			const searchText = queryText.toLowerCase()
			this.textoBuscaOrgao = queryText
			return textoSiglaDescricao.indexOf(searchText) > -1
		},
	},
}
</script>
<style lang="stylus" scoped>
.texto-subtitulo
	font-size 22px
</style>
